// removed by extract-text-webpack-plugin
module.exports = {"Container":"resetPassword__Container__13qBB","ResetPasswordContainer":"resetPassword__ResetPasswordContainer__QxqW1","Title":"resetPassword__Title__2vSyo","ErrorMsg":"resetPassword__ErrorMsg__3x-LG","Error":"resetPassword__Error__TIl96","Form":"resetPassword__Form__-O9sL","Submit":"resetPassword__Submit__2c3eR","Loading":"resetPassword__Loading__1OwMq"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/ResetPassword/resetPassword.css
// module id = 1258
// module chunks = 2